import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        setSession(data);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center"><Loader2 className="w-10 h-10 mx-auto text-[#0047AB] animate-spin mb-3" /><p className="text-neutral-500">Signing you in…</p></div>
    </div>
  );
}
